import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { MdEdit, MdDone, MdClear, MdCameraAlt } from 'react-icons/md';
import user1Image from '../assets/img/users/100_1.jpg';
import Page from '../components/Page';
import axios from 'axios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import Avatar from '../components/Avatar';
import userImage from '../assets/img/users/profile.jpg';

import UploadPhotoForm from '../components/UploadPhotoForm';

const url = process.env.REACT_APP_API_URL;

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      contact: '',
      email: '',
      type: null,
      newName: '',
      newContact: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      isMatch: true,
      imagePreviewUrl: '',
      photo: '',
      isUpload: false,
      modal: false,
      photoModal: false,
      isCompanyLogo: false,
    };
  }

  get resetState() {
    return {
      name: '',
      contact: '',
      email: '',
      type: null,
      newName: '',
      newContact: '',
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
      isMatch: true,
      photo: '',
      imagePreviewUrl: '',
      isUpload: false,
      modal: false,
      photoModal: false,
    };
  }

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      photoModal: false,
    });

    if (reload) {
      window.location.reload();
    }
  };

  handleImageChange = event => {
    if (event.target.files && event.target.files.length > 0) {
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onloadend = () => {
        this.setState({
          photo: reader.result,
          imagePreviewUrl: reader.result,
          isUpload: !this.state.isUpload,
          type: 'PROFILE',
        });
      };

      reader.readAsDataURL(file);
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    if (
      event.target.name === 'newPassword' &&
      this.state.confirmPassword !== null &&
      this.state.confirmPassword !== ''
    ) {
      setTimeout(() => this.comparePassword(), 500);
    }

    if (event.target.name === 'confirmPassword') {
      setTimeout(() => this.comparePassword(), 500);
    }
  };

  discard = () => {
    const user = StorageService.getSession('user_info');
    this.setState({
      photo: user.photo ? user.photo : '',
      imagePreviewUrl: user.photo ? user.photo : '',
      isUpload: !this.state.isUpload,
      type: null,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');

    const data = {
      session_key: user.session_key,
      userId: user.userId,
    };

    let api = '';

    if (this.state.type === 'PROFILE') {
      data.name = this.state.name;
      data.contact = this.state.contact;
      data.photo = this.state.photo;
      api = ':3000/v1/user/update-profile';
    } else {
      data.oldPassword = this.state.currentPassword;
      data.newPassword = this.state.newPassword;
      api = ':3000/v1/user/update-password';
    }

    axios
      .post(url + api, data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.notificationSystem.addNotification({
            title: <MdClear />,
            message: 'Update failed',
            level: 'error',
            position: 'br',
            autoDismiss: 2,
            dismissible: 'click',
          });
          return;
        }

        if (this.state.type === 'PROFILE') {
          StorageService.setSession('user_info', result.data);
        }

        this.notificationSystem.addNotification({
          title: <MdDone />,
          message:
            this.state.type === 'PROFILE'
              ? 'Profile updated successfully'
              : 'Password updated successfully',
          level: 'success',
          position: 'br',
          autoDismiss: 2,
          dismissible: 'click',
        });
        window.location.reload();
        //this.setState(this.resetState);
        //this.getUserInfo();
      })
      .catch(error => {
        if (error.response.status === 401) {
          alert('Update failed. Incorrect current password');
        } else {
          alert('Bad request');
        }
      });
  };

  toggle = type => () => {
    return this.setState({
      modal: !this.state.modal,
      type: type,
    });
  };

  togglePhotoModal = e => () => {
    return this.setState({
      photoModal: !this.state.photoModal,
    });
  };

  getUserInfo = () => {
    const user = StorageService.getSession('user_info');
    this.setState({
      name: user.name,
      contact: user.contact,
      email: user.email,
      imagePreviewUrl: user.photo,
      photo: user.photo,
    });
  };

  comparePassword = () => {
    const newPassword = this.state.newPassword;
    const confirmPassword = this.state.confirmPassword;

    let match = confirmPassword === newPassword ? true : false;

    this.setState({
      isMatch: match,
    });
  };

  componentDidMount() {
    this.setState(this.resetState);
    this.getUserInfo();
  }

  render() {
    return (
      <Page
        className="ProfilePage"
        title="Profile"
        breadcrumbs={[{ name: 'Profile', active: true }]}
      >
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        <Row>
          <Col xl={6} lg={12} md={12}>
            <Card className="mb-3">
              <CardHeader>Your Photo</CardHeader>
              <CardBody>
                <Form onSubmit={this.handleSubmit}>
                  <div className="mb-3 text-center">
                    <Avatar
                      className="mx-auto profile-img"
                      src={
                        this.state.imagePreviewUrl === null ||
                        this.state.imagePreviewUrl === ''
                          ? userImage
                          : this.state.imagePreviewUrl
                      }
                    />
                  </div>

                  <div className="text-center">
                    <Button
                      className="theme-button theme-button-primary d-block mx-auto"
                      onClick={this.togglePhotoModal()}
                    >
                      <MdCameraAlt /> Change
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Card style={{ height: 'auto' }}>
              <CardHeader>Account Details</CardHeader>
              <CardBody>
                <Row form>
                  <Col md={6}>
                    <Label>Name</Label>
                    <p>
                      {this.state.name === null || this.state.name === ''
                        ? 'None'
                        : this.state.name}
                    </p>
                  </Col>
                </Row>
                <Row form>
                  <Col md={6}>
                    <Label>Email</Label>
                    <p>
                      {this.state.email === null || this.state.email === ''
                        ? 'None'
                        : this.state.email}
                    </p>
                  </Col>
                  <Col md={6}>
                    <Label>Contact No.</Label>
                    <p>
                      {this.state.contact === null || this.state.contact === ''
                        ? 'None'
                        : this.state.contact}
                    </p>
                  </Col>
                </Row>
                <div className="text-right">
                  <Button
                    className="theme-button theme-button-primary"
                    onClick={this.toggle('PROFILE')}
                  >
                    Edit
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl={6} lg={12} md={12}>
            <Card>
              <CardHeader>Your Password</CardHeader>
              <CardBody>
                <Row form>
                  <Col md={6}>
                    <Label>Set New Password</Label>
                    <Button
                      className="theme-button theme-button-primary d-block"
                      onClick={this.toggle('PASSWORD')}
                    >
                      Change Password
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <Form className="AuthForm ps-form" onSubmit={this.handleSubmit}>
            <ModalHeader toggle={this.toggle()}>
              {this.state.type === 'PROFILE'
                ? 'Update Profile'
                : 'Change Password'}
            </ModalHeader>
            <ModalBody>
              {this.state.type === 'PROFILE' ? (
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <p>{this.state.email}</p>
                    </FormGroup>

                    <FormGroup>
                      <Label for="newName">Name</Label>
                      <Input
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={this.changeHandler}
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="newContact">Contact</Label>
                      <Input
                        type="text"
                        name="contact"
                        value={this.state.contact}
                        onChange={this.changeHandler}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="currentPassword">Current Password</Label>
                      <Input
                        type="password"
                        name="currentPassword"
                        value={this.state.currentPassword}
                        onChange={this.changeHandler}
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="newPassword">New Password</Label>
                      <Input
                        type="password"
                        name="newPassword"
                        value={this.state.newPassword}
                        onChange={this.changeHandler}
                        required
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label for="confirmPassword">Confirm Password</Label>
                      <Input
                        type="password"
                        name="confirmPassword"
                        value={this.state.confirmPassword}
                        onChange={this.changeHandler}
                        required
                      />
                      <span
                        className={`ps-sm-msg ${
                          this.state.isMatch ? ' hide' : ''
                        }`}
                      >
                        New password and confirm password does not match
                      </span>
                    </FormGroup>
                  </Col>
                </Row>
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                className="theme-button theme-button-secondary"
                onClick={this.toggle()}
              >
                Close
              </Button>
              <Button
                className="theme-button theme-button-primary"
                type="submit"
              >
                Save Changes
              </Button>{' '}
            </ModalFooter>
          </Form>
        </Modal>

        <Modal
          isOpen={this.state.photoModal}
          toggle={this.togglePhotoModal()}
          className={this.props.className}
          centered
        >
          <UploadPhotoForm
            history={this.props.history}
            onToggleModal={this.togglePhotoModal}
            closeModal={this.closeModal}
            data={this.state}
          />
        </Modal>
      </Page>
    );
  }
}
export default ProfilePage;
